import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  contentBtn: {

    paddingHorizontal: 25,
    width: '100%'
  },
  text: {
    paddingHorizontal: 12,
    paddingTop: 12,
    marginTop: 12,
    maxWidth: 350,
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    shadowColor: "#000",
        shadowOffset: {
        width: 0,
        height: 4,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4.84,
        elevation: 4
  },
  list: {
    paddingVertical: 15,
    fontSize: 14,
    lineHeight: 20,
  },
  bold: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#077A97',
    fontSize: 16,
    marginBottom: 12,
  },
  btn: {
    fontFamily: 'Poppins, sans-serif',
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: 'center',
    color: '#fff',
  },
  textBtn: {
    color: '#fff',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '500'
  }
});

export default styles;
